import React from 'react';
import BaseText from '../typography/BaseText';
import { FONT_SIZE } from '../../../constants/enum';
export default function Input({ label, inputProps, error, placeholder }) {
  return (
    <div className="w-full">
      <BaseText fontSize={FONT_SIZE.PX_14} fontWeight="text-regular" title={label} className="my-2" />
      <input
        {...inputProps}
        placeholder={placeholder}
        className="border text-medium px-3 border-gray-180 placeholder-gray-180 rounded-lg h-12 bg-gray-100 w-full"
      />
      {error && (
        <BaseText fontSize={FONT_SIZE?.PX_14} textColor="text-red-500" title={`Please enter a valid ${error}`} />
      )}
    </div>
  );
}
